import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

momentDurationFormatSetup(moment);

moment.updateLocale('de', {
  durationLabelsStandard: {
    S: 'Millisekunde',
    SS: 'Millisekunden',
    s: 'Sekunde',
    ss: 'Sekunden',
    m: 'Minute',
    mm: 'Minuten',
    h: 'Stunde',
    hh: 'Stunden',
    d: 'Tag',
    dd: 'Tage',
    w: 'Woche',
    ww: 'Wochen',
    M: 'Monat',
    MM: 'Monate',
    y: 'Jahr',
    yy: 'Jahre',
  },
  durationLabelsShort: {
    S: 'msec',
    SS: 'msecs',
    s: 'sec',
    ss: 'secs',
    m: 'min',
    mm: 'mins',
    h: 'hr',
    hh: 'hrs',
    d: 'dy',
    dd: 'dys',
    w: 'wk',
    ww: 'wks',
    M: 'mo',
    MM: 'mos',
    y: 'yr',
    yy: 'yrs',
  },
});

export default moment;
